import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1ea8d2f3")
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = {
  class: "modal__body",
  ref: "modal"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Persoon zoeken", -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  style: {"margin-top":"16px"}
}
const _hoisted_6 = { style: {"margin-bottom":"8px"} }
const _hoisted_7 = { class: "search-results" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "person-button__name" }
const _hoisted_10 = { class: "person-button__birthdate" }
const _hoisted_11 = {
  key: 1,
  style: {"margin-top":"16px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"8px"} }, "Zoekresultaten (0)", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0"} }, "Er zijn geen resultaten voor deze zoekopdracht.", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: ".modals" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "modal__close",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancelClick && _ctx.onCancelClick(...args)), ["prevent"]))
        }, "Annuleren"),
        (!_ctx.flags.addNewPerson)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _createElementVNode("form", {
                novalidate: "",
                autocomplete: "off",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSearchSubmit && _ctx.onSearchSubmit(...args)), ["prevent"])),
                style: {"display":"flex"}
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "control",
                  placeholder: "Zoekopdracht...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event)),
                  ref: "searchQueryField"
                }, null, 512), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _createElementVNode("button", {
                  class: "button is-green",
                  style: {"margin-left":"16px"},
                  disabled: _ctx.loading
                }, "Zoeken", 8, _hoisted_4)
              ], 32),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.searchResults && _ctx.searchResults.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("h2", _hoisted_6, "Zoekresultaten (" + _toDisplayString(_ctx.searchResults.length) + ")", 1),
                          _createElementVNode("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (searchResult) => {
                              return (_openBlock(), _createElementBlock("button", {
                                class: "person-button",
                                onClick: _withModifiers(($event: any) => (_ctx.onPersonClick(searchResult.id)), ["prevent"])
                              }, [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(searchResult.nickname || searchResult.firstNames) + " " + _toDisplayString(searchResult.lastName) + _toDisplayString(searchResult.maidenName && searchResult.maidenName.length > 0 ? `-${searchResult.maidenName}` : ''), 1),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(searchResult.bornAt && searchResult.bornAt.length > 0 ? _ctx.showDate(searchResult.bornAt) : 'geboortedatum onbekend'), 1)
                              ], 8, _hoisted_8))
                            }), 256))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.searchResults && _ctx.searchResults.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ], 512)
    ])
  ]))
}